import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import {
  create_base_target,
  get_current_base_target_month_date,
  set_shop_target,
} from '@/api/mjstat-model';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import ls from '@/utils/local-storage';
import { reactive } from 'vue';
import { message } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';

export const event_obj = mitt();
const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

export const btn_list = [
  {
    name: '编辑',
    clazz: 'primary',
    cb: (data: any) => {
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '编辑目标',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
            labelCol: {
              span: 8,
            },
            wrapperCol: {
              span: 16,
            },
          },
          fields: [
            {
              type: 'monthpicker',
              name: 'date',
              label: '月份',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM',
              valueFormat: 'YYYY-MM',
              placeholder: '请选择月份',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '门店',
              disabled: false,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'number',
              name: 'cz_price_percent',
              label: '收款目标增长(%)',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写收款目标增长',
            },
            {
              type: 'number',
              name: 'cz_avg_price_percent',
              label: '人均收款目标增长(%)',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写人均收款目标增长',
            },
            {
              type: 'number',
              name: 'used_price_percent',
              label: '耗卡目标增长(%)',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写耗卡目标增长',
            },
            {
              type: 'number',
              name: 'used_customer_percent',
              label: '客流目标增长(%)',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写客流目标增长',
            },
          ],
          rules: {
            date: [{ required: true, message: '请填月份' }],
            shop_id: [{ required: true, message: '请选择门店' }],
            cz_price_percent: [{ required: true, message: '请填收款目标增长' }],
            cz_avg_price_percent: [{ required: true, message: '请填人均收款目标增长' }],
            used_price_percent: [{ required: true, message: '请填耗卡目标增长' }],
            used_customer_percent: [{ required: true, message: '请填客流目标增长' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            date: data.date,
            shop_id: data.shop_id,
            cz_price_percent: data.cz_price_percent,
            cz_avg_price_percent: data.cz_avg_price_percent,
            used_price_percent: data.used_price_percent,
            used_customer_percent: data.used_customer_percent,
          }),
          watch: {},
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            set_shop_target({
              ...payload,
              date: payload.date + '-01',
            })
              .then(() => {
                message.success('修改成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [
  {
    name: '新建目标',
    clazz: 'primary',
    cb: () => {
      get_current_base_target_month_date({
        org_id: current_org.id,
      }).then((res: any) => {
        const editModal = reactive({
          visible: true,
          loading: false,
          title: '新建基础目标',
          form: {
            settings: {
              labelAlign: 'right',
              layout: 'horizontal',
              col: [],
              labelCol: {
                span: 7,
              },
              wrapperCol: {
                span: 17,
              },
            },
            fields: [
              {
                type: 'monthpicker',
                name: 'date',
                label: '月份',
                disabled: false,
                allowClear: true,
                inputType: 'number',
                defaultValue: '',
                format: 'YYYY-MM',
                valueFormat: 'YYYY-MM',
                placeholder: '请选择月份',
              },
              {
                type: 'number',
                name: 'cz_price_percent',
                label: '收款目标增长',
                disabled: false,
                allowClear: true,
                inputType: 'number',
                defaultValue: '',
                placeholder: '请填写收款目标增长',
              },
              {
                type: 'number',
                name: 'cz_avg_price_percent',
                label: '人均收款目标增长',
                disabled: false,
                allowClear: true,
                inputType: 'number',
                defaultValue: '',
                placeholder: '请填写人均收款目标增长',
              },
              {
                type: 'number',
                name: 'used_price_percent',
                label: '耗卡目标增长',
                disabled: false,
                allowClear: true,
                inputType: 'number',
                defaultValue: '',
                placeholder: '请填写耗卡目标增长',
              },
              {
                type: 'number',
                name: 'used_customer_percent',
                label: '客流目标增长',
                disabled: false,
                allowClear: true,
                inputType: 'number',
                defaultValue: '',
                placeholder: '请填写客流目标增长',
              },
            ],
            rules: {
              date: [{ required: true, message: '请填月份' }],
              cz_price_percent: [{ required: true, message: '请填收款目标增长' }],
              cz_avg_price_percent: [{ required: true, message: '请填人均收款目标增长' }],
              used_price_percent: [{ required: true, message: '请填耗卡目标增长' }],
              used_customer_percent: [{ required: true, message: '请填客流目标增长' }],
            },
            model: reactive({
              org_id: current_org?.id,
              is_active: true,
              date: res,
              cz_price_percent: null,
              cz_avg_price_percent: null,
              used_price_percent: null,
              used_customer_percent: null,
            }),
            watch: {},
          },
          options: {},
          ok: (payload: any) => {
            return new Promise(resolve => {
              editModal.loading = true;
              create_base_target(payload)
                .then(() => {
                  message.success('新建基础目标成功');
                  event_obj.emit('refresh');
                  resolve(null);
                })
                .finally(() => {
                  editModal.loading = false;
                });
            });
          },
        });
        modalBox(editModal);
      });
    },
  },
];
